import { gql } from 'glimmer-apollo';
import { GAME_ARTICLE_FRAGMENT, ESPORTS_ARTICLE_FRAGMENT } from '../fragments/common';

export const GET_HOME_PAGE_PAGINATED = gql`
  ${GAME_ARTICLE_FRAGMENT}
  ${ESPORTS_ARTICLE_FRAGMENT}

  query HomePagePaginatedQuery($page: Int = 1, $limit: Int = 8) {
    eSportsArticles: eSportsArticlesPaginated(page: $page, limit: $limit) {
      items {
        ...ESportsArticleInfo
      }
      totalCount
      page
      limit
      hasNextPage
      hasPreviousPage
    }
    gameArticles: gameArticlesPaginated(page: $page, limit: $limit) {
      items {
        ...GameArticleInfo
      }
      totalCount
      page
      limit
      hasNextPage
      hasPreviousPage
    }
    newsSlider: eSportsArticles(limit: 4) {
      ...ESportsArticleInfo
    }
    topGameArticles: gameArticles(limit: 2) {
      ...GameArticleInfo
    }
    topESportsArticles: eSportsArticles(limit: 2) {
      ...ESportsArticleInfo
    }
    popularGameArticles: gameArticles(limit: 2) {
      ...GameArticleInfo
    }
    popularESportsArticles: eSportsArticles(limit: 2) {
      ...ESportsArticleInfo
    }
  }
`;